import gql from 'graphql-tag';

import type { ReviewerProject } from 'src/data/project';
import { executeGqlQuery } from 'src/graphql/client';
import {
  getSingleProp,
  isGraphQLProjectNoAccessResult,
  throwIfResultHasErrors,
} from 'src/lib/graphql';
import type { BackendQueryProjectArgs } from 'src/types/backend';

// Only fields a reviewer may read: anything else fails the whole request with an access error.
const QUERY = gql`
  query ReviewerProject($id: Int!) {
    project(id: $id) {
      id
      name
      editorContent
      customer {
        id
      }
    }
  }
`;

type Variables = BackendQueryProjectArgs;

export const queryReviewerProject = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  const project = getSingleProp<ReviewerProject | null>(result.data);
  // A project the caller can't open comes back as null, with the reason in `errors`.
  if (project === null && isGraphQLProjectNoAccessResult(result)) {
    return null;
  }
  throwIfResultHasErrors(result);
  return project ?? null;
};
